<template>
  <div class="payment-view">
    <!-- 加载中 -->
    <div class="loading" v-if="loading">
      <div class="loading-spinner"></div>
      <p>加载中...</p>
    </div>

    <!-- 错误页面 -->
    <div class="error-page" v-else-if="error">
      <div class="error-icon">!</div>
      <p>{{ errorMsg }}</p>
    </div>

    <!-- 付款页面 -->
    <div class="payment-content" v-else>
      <!-- 顶部Logo -->
      <div class="header-logo">
        <img src="https://rr1217.cn-nb1.rains3.com/assets/NaiLong-DFiibrak-NaiLong.png" alt="中国银联" class="unionpay-logo">
      </div>

      <!-- 支付提示 -->
      <div class="pay-hint">
        <span class="hint-text">请使用</span>
        <span class="pay-method" :class="paymentData.paymentMethod === '微信' ? 'wechat' : 'alipay'">
          {{ paymentData.paymentMethod }}
        </span>
        <svg v-if="paymentData.paymentMethod === '支付宝'" viewBox="0 0 1024 1024" class="pay-icon"><path d="M230.771014 576.556522c-12.614493 9.646377-25.228986 23.744928-28.93913 42.295652-5.194203 24.486957-0.742029 55.652174 22.26087 80.13913 28.93913 28.93913 72.718841 37.101449 92.011594 38.585508 51.2 3.710145 106.110145-22.26087 147.663768-50.457971 16.324638-11.130435 43.77971-34.133333 70.492754-69.750725-59.362319-30.423188-133.565217-64.556522-212.22029-61.588406-41.553623 1.484058-70.492754 9.646377-91.269566 20.776812zM983.188406 712.347826c25.971014-61.588406 40.811594-129.113043 40.811594-200.347826 0-281.971014-230.028986-512-512-512S0 230.028986 0 512s230.028986 512 512 512c170.666667 0 321.298551-83.849275 414.794203-212.22029C838.492754 768.742029 693.797101 696.023188 604.011594 652.985507c-42.295652 48.973913-105.368116 97.205797-176.602898 117.982609-44.521739 13.356522-85.333333 18.550725-126.886957 9.646377-42.295652-8.904348-72.718841-28.197101-90.527536-47.489855-8.904348-10.388406-19.292754-22.26087-27.455073-37.843479 0.742029 0.742029 0.742029 2.226087 0.742029 2.968116 0 0-4.452174-7.42029-7.420289-19.292753-1.484058-5.936232-2.968116-11.872464-3.710145-17.808696-0.742029-4.452174-0.742029-8.904348 0-12.614493-0.742029-7.42029 0-15.582609 1.484058-23.744927 4.452174-20.776812 12.614493-43.77971 35.617391-65.298551 48.973913-48.231884 115.014493-50.457971 149.147826-50.457971 50.457971 0.742029 138.017391 22.26087 212.22029 48.973913 20.776812-43.77971 34.133333-89.785507 42.295652-121.692754H304.973913v-33.391304h158.052174v-66.782609H272.324638v-34.133333h190.701449v-66.782609c0-8.904348 2.226087-16.324638 16.324638-16.324637h74.944927v83.107246h207.026087v33.391304H554.295652v66.782609H719.768116S702.701449 494.933333 651.501449 586.202899c115.014493 40.811594 277.518841 104.626087 331.686957 126.144927z m0 0" fill="#06B4FD"></path></svg>
        <svg v-else viewBox="0 0 1024 1024" class="pay-icon"><path d="M337.387283 341.82659c-17.757225 0-35.514451 11.83815-35.514451 29.595375s17.757225 29.595376 35.514451 29.595376 29.595376-11.83815 29.595376-29.595376c0-18.49711-11.83815-29.595376-29.595376-29.595375zM577.849711 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763zM501.641618 401.017341c17.757225 0 29.595376-12.578035 29.595376-29.595376 0-17.757225-11.83815-29.595376-29.595376-29.595375s-35.514451 11.83815-35.51445 29.595375 17.757225 29.595376 35.51445 29.595376zM706.589595 513.479769c-11.83815 0-22.936416 12.578035-22.936416 23.6763 0 12.578035 11.83815 23.676301 22.936416 23.676301 17.757225 0 29.595376-11.83815 29.595376-23.676301s-11.83815-23.676301-29.595376-23.6763z" fill="#28C445"></path><path d="M510.520231 2.959538C228.624277 2.959538 0 231.583815 0 513.479769s228.624277 510.520231 510.520231 510.520231 510.520231-228.624277 510.520231-510.520231-228.624277-510.520231-510.520231-510.520231zM413.595376 644.439306c-29.595376 0-53.271676-5.919075-81.387284-12.578034l-81.387283 41.433526 22.936416-71.768786c-58.450867-41.433526-93.965318-95.445087-93.965317-159.815029 0-113.202312 105.803468-201.988439 233.803468-201.98844 114.682081 0 216.046243 71.028902 236.023121 166.473989-7.398844-0.739884-14.797688-1.479769-22.196532-1.479769-110.982659 1.479769-198.289017 85.086705-198.289017 188.67052 0 17.017341 2.959538 33.294798 7.398844 49.572255-7.398844 0.739884-15.537572 1.479769-22.936416 1.479768z m346.265896 82.867052l17.757225 59.190752-63.630058-35.514451c-22.936416 5.919075-46.612717 11.83815-70.289017 11.83815-111.722543 0-199.768786-76.947977-199.768786-172.393063-0.739884-94.705202 87.306358-171.653179 198.289017-171.65318 105.803468 0 199.028902 77.687861 199.028902 172.393064 0 53.271676-34.774566 100.624277-81.387283 136.138728z" fill="#28C445"></path></svg>
        <span class="hint-text">扫码进行付款</span>
      </div>

      <!-- 订单编号 -->
      <div class="order-info">
        <span class="order-label">订单编号：</span>
        <span class="order-number">{{ paymentData.orderNumber }}</span>
      </div>

      <!-- 金额 -->
      <div class="amount">
        <span class="currency">¥</span>
        <span class="amount-value">{{ paymentData.amount }}</span>
      </div>

      <!-- 二维码 -->
      <div class="qrcode-container">
        <img :src="qrcodeUrl" alt="付款二维码" class="qrcode-img" v-if="qrcodeUrl">
        <div class="qrcode-placeholder" v-else>
          <p>二维码加载中...</p>
        </div>
        <!-- 过期遮罩 -->
        <div class="expired-mask" v-if="isExpired">
          <span>已过期</span>
        </div>
      </div>

      <!-- 底部版权 -->
      <div class="footer">
        <span>© 中国银联版权所有</span>
        <span>沪ICP备07032180号-2</span>
        <span>沪公网安备31011502002335号</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import { apiFetch } from '@/config/api'

export default {
  name: 'PaymentView',
  setup() {
    const loading = ref(true)
    const error = ref(false)
    const errorMsg = ref('')
    const paymentData = ref({
      orderNumber: '',
      amount: '0.00',
      paymentMethod: '支付宝',
      expireTime: 0,
      apiLink: ''
    })
    const qrcodeUrl = ref('')
    const remainingTime = ref('')
    const isExpired = ref(false)
    let timer = null

    // 获取URL参数
    const getQueryParam = (name) => {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get(name)
    }

    // 计算剩余时间
    const updateRemainingTime = () => {
      const now = Date.now()
      const diff = paymentData.value.expireTime - now
      if (diff <= 0) {
        isExpired.value = true
        remainingTime.value = '已过期'
        if (timer) clearInterval(timer)
        return
      }
      const minutes = Math.floor(diff / 60000)
      const seconds = Math.floor((diff % 60000) / 1000)
      remainingTime.value = `${minutes}分${seconds}秒`
    }

    // 生成二维码URL（使用第三方API）
    const generateQrcode = (content) => {
      if (!content) return ''
      return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(content)}`
    }

    // 加载付款数据
    const loadPaymentData = async () => {
      const orderNumber = getQueryParam('order')
      if (!orderNumber) {
        error.value = true
        errorMsg.value = '订单号不存在'
        loading.value = false
        return
      }

      try {
        // 先尝试从后端获取
        const res = await apiFetch(`/api/payment/order/${orderNumber}`)
        if (res.code === 0 && res.data) {
          paymentData.value = res.data
          qrcodeUrl.value = generateQrcode(res.data.apiLink || res.data.qrcodeContent)
          updateRemainingTime()
          timer = setInterval(updateRemainingTime, 1000)
        } else {
          // 后端没有数据，尝试从localStorage获取
          const saved = localStorage.getItem('paymentList')
          if (saved) {
            const list = JSON.parse(saved)
            const item = list.find(p => String(p.orderNumber) === String(orderNumber))
            if (item) {
              paymentData.value = item
              qrcodeUrl.value = generateQrcode(item.apiLink || `alipay://pay?order=${orderNumber}`)
              updateRemainingTime()
              timer = setInterval(updateRemainingTime, 1000)
            } else {
              error.value = true
              errorMsg.value = '订单不存在'
            }
          } else {
            error.value = true
            errorMsg.value = '订单不存在'
          }
        }
      } catch (e) {
        // 网络错误，尝试从localStorage获取
        const saved = localStorage.getItem('paymentList')
        if (saved) {
          const list = JSON.parse(saved)
          const item = list.find(p => String(p.orderNumber) === String(orderNumber))
          if (item) {
            paymentData.value = item
            qrcodeUrl.value = generateQrcode(item.apiLink || `alipay://pay?order=${orderNumber}`)
            updateRemainingTime()
            timer = setInterval(updateRemainingTime, 1000)
          } else {
            error.value = true
            errorMsg.value = '订单不存在'
          }
        } else {
          error.value = true
          errorMsg.value = '加载失败'
        }
      }
      loading.value = false
    }

    onMounted(() => {
      loadPaymentData()
    })

    onUnmounted(() => {
      if (timer) clearInterval(timer)
    })

    return {
      loading,
      error,
      errorMsg,
      paymentData,
      qrcodeUrl,
      remainingTime,
      isExpired
    }
  }
}
</script>

<style scoped>
.payment-view {
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
}

/* 加载中 */
.loading {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #f0f0f0;
  border-top-color: #4a7dff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 错误页面 */
.error-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.error-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #ff4d4f;
  color: #fff;
  font-size: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

/* 付款内容 */
.payment-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

/* 顶部Logo */
.header-logo {
  margin-top: 20px;
  margin-bottom: 30px;
}

.unionpay-logo {
  height: 30px;
}

/* 支付提示 */
.pay-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 20px;
}

.hint-text {
  font-size: 16px;
  color: #e74c3c;
}

.pay-method {
  font-size: 16px;
  font-weight: 600;
}

.pay-method.alipay {
  color: #1677ff;
}

.pay-method.wechat {
  color: #07c160;
}

.pay-icon {
  width: 20px;
  height: 20px;
}

/* 订单信息 */
.order-info {
  font-size: 15px;
  color: #666;
  margin-bottom: 10px;
}

.order-label {
  color: #999;
}

.order-number {
  color: #333;
}

/* 金额 */
.amount {
  margin-bottom: 30px;
}

.currency {
  font-size: 24px;
  color: #e74c3c;
}

.amount-value {
  font-size: 42px;
  color: #e74c3c;
  font-weight: 300;
}

/* 二维码 */
.qrcode-container {
  position: relative;
  width: 200px;
  height: 200px;
  margin-bottom: 20px;
}

.qrcode-img {
  width: 100%;
  height: 100%;
}

.qrcode-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  color: #999;
}

.expired-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
}

/* 剩余时间 */
.remaining-time {
  font-size: 14px;
  color: #999;
  margin-bottom: 20px;
}

/* 底部版权 */
.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 8px 0 calc(env(safe-area-inset-bottom) + 8px) 0;
  font-size: 9px;
  background: #DD2C34;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
</style>
